export const setCustomDataArray = <T extends { field_index: number; field_value: string | null }>(
  customDataArray: T[] | undefined | null,
) => {
  if (!customDataArray) {
    return;
  }

  for (let i = 0; i < customDataArray.length; i++) {
    if (!(i in customDataArray)) {
      customDataArray[i] = {
        ...customDataArray[i],
        field_index: i,
        field_value: null,
      };
    } else {
      customDataArray[i] = {
        ...customDataArray[i],
        field_index: i,
      };
    }
  }
};
